import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { getSizeScenario } from '../../selectors/entities/general';

import Builder from './BuilderPage';

export default connect(
    (state) => ({
        sizeScenario: getSizeScenario(state),
    }),
    (dispatch) => ({
        actions: bindActionCreators({}, dispatch)
    })
)(Builder)